export default __webpack_public_path__ + "static/media/Bobo-avatar.264e7ed6.jpg";